import { Platform } from "react-native";

export const webModalOptions =
  Platform.OS === "web"
    ? {
        presentation: "transparentModal" as const,
        headerShown: false,
        contentStyle: {
          backgroundColor: "transparent",
        } as const,
      }
    : {};

export const WEB_MODAL_DEFAULT_WIDTH = 720;
